<template>
  <div
    v-if="Object.keys(store.groupedSearchedMinistersByMinistries).length"
    class="cards-wrapper"
  >
    <MinistryCard
      v-for="ministryName in Object.keys(
        store.groupedSearchedMinistersByMinistries
      )"
      :key="ministryName"
      :ministry-name="ministryName"
    />
  </div>
  <div v-else class="card">
    <AbstractNoData>
      <template #message>
        Nous n’avons pas trouvé de ministre correspondant à votre recherche
      </template>
      <template #image>
        <Minerve
          expression="lecture"
          detail="mid"
          :mouvements="['read']"
          :taille="56"
        />
      </template>
    </AbstractNoData>
  </div>
</template>

<script setup>
import MinistryCard from "@follaw-fr/components/cabinets/organisms/MinistryCard.vue";
import { useCabinetsStore } from "@follaw-fr/stores/cabinets";
import AbstractNoData from "@follaw-fr/components/reusable/abstract/AbstractNoData.vue";
import Minerve from "@follaw-fr/components/reusable/minerve/Minerve";

const store = useCabinetsStore();
</script>

<style lang="scss" scoped>
.cards-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
